// Configuración centralizada para la información del sitio
// Modifique estos valores para cambiar la información en todos los componentes

export const SITE_INFO = {
  // Nombre del sitio
  siteName: "TVCIELO",
  
  // Número de teléfono WhatsApp
  phoneNumber: "+44 7446953975",
  
  // Correo electrónico de contacto
  email: "contact@tvcielo.com",
  
  // URL de WhatsApp completa
  whatsappUrl: "https://wa.me/447446953975",
  
  // URL del sitio web
  websiteUrl: "https://tvhamza.com"
};

// Función de utilidad para formatear el número de teléfono
export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/\s/g, '');
};

// Función de utilidad para crear la URL de WhatsApp
export const createWhatsAppUrl = (phoneNumber, message = "") => {
  const cleanNumber = formatPhoneNumber(phoneNumber);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};

// Función de utilidad para crear un enlace de correo electrónico
export const createEmailUrl = (email, subject = "", body = "") => {
  const encodedSubject = encodeURIComponent(subject || "Solicitud de información");
  const encodedBody = encodeURIComponent(body || "Hola,\n\nDeseo obtener más información sobre sus servicios de IPTV.\n\nCordialmente");
  return `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`;
};
